import React from 'react';
import './Drawcanvas.css';
import NewGame from './NewGame';
import Player from './Player';

function GameOverWin(props) {
    return (
      <div className={props.display + " shrink-0 absolute GameOverWin bg-white shadow-2xl w-2/3 md:w-1/4 shadow-lg sm:p-5 text-base text-gray-700 text-xl grid place-content-center fakerLost rounded"}>
        <p className=''>The fake artist, <Player player={props.faker} />, has been discovered and has lost!</p>
        <p className='pb-8 w-full'>The secret word was {props.secret}</p>
        <NewGame socket={props.socket}/>
      </div>
    );
  
}

export default GameOverWin;
